import React from 'react';

import {
  siteFacebookPage,
  siteInstagramPage,
  siteLinkedInPage,
  siteTiktokPage,
  siteYouTubePage,
} from '../../../marketplace-links';
import { neutral } from '../../../styles/mui/colors';
import IconFacebook from '../../Icons/IconFacebook';
import IconInstagram from '../../Icons/IconInstagram';
import IconLinkedIn from '../../Icons/IconLinkedIn';
import IconTikTok from '../../Icons/IconTikTok';
import IconYouTube from '../../Icons/IconYouTube';
import ExternalLink from '../../Links/ExternalLink/ExternalLink';

const linkStyle = {
  display: 'inline-block',
  width: '20px',
  height: '24px',
  marginRight: '12px',
  textAlign: 'center',
};

/**
 * util for footer
 * @param intl
 * @returns {React.JSX.Element[]}
 */
export const renderSocialMediaLinks = (intl) => {
  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTiktok = intl.formatMessage({ id: 'Footer.goToTiktok' });
  const goToLinkedIn = intl.formatMessage({ id: 'Footer.goToLinkedIn' });
  const goToYouTube = intl.formatMessage({ id: 'Footer.goToYouTube' });

  const fbLink = siteFacebookPage ? (
    <ExternalLink href={siteFacebookPage} key="linkToFacebook" style={linkStyle} title={goToFb}>
      <IconFacebook sx={{ color: neutral[400] }} />
    </ExternalLink>
  ) : null;

  const tiktokLink = siteTiktokPage ? (
    <ExternalLink href={siteTiktokPage} key="linkToTiktok" style={linkStyle} title={goToTiktok}>
      <IconTikTok sx={{ color: neutral[400] }} />
    </ExternalLink>
  ) : null;
  const linkedInLink = siteLinkedInPage ? (
    <ExternalLink
      href={siteLinkedInPage}
      key="linkToLinkedIn"
      style={linkStyle}
      title={goToLinkedIn}
    >
      <IconLinkedIn sx={{ color: neutral[400] }} />
    </ExternalLink>
  ) : null;

  const instagramLink = siteInstagramPage ? (
    <ExternalLink
      href={siteInstagramPage}
      key="linkToInstagram"
      style={linkStyle}
      title={goToInsta}
    >
      <IconInstagram sx={{ color: neutral[400] }} />
    </ExternalLink>
  ) : null;
  const youtubeLink = siteYouTubePage ? (
    <ExternalLink href={siteYouTubePage} key="linkToYouTube" style={linkStyle} title={goToYouTube}>
      <IconYouTube sx={{ color: neutral[400] }} />
    </ExternalLink>
  ) : null;
  return [fbLink, instagramLink, tiktokLink, linkedInLink, youtubeLink].filter((v) => v != null);
};
